import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import css from './Blends.module.scss';
import LazyImg from '../LazyImg';
import windowHeight from '../../utils/dom/windowHeight';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var INCREMENT_AMOUNT = 1.25; // move blend image up/down by this amount in pixels

var MAX_TRANSLATE = 270; // max translated pixels for blend image

var THRESHOLD_STEPS = 800; // number of values between 0 and 1

var getPercents = function getPercents(endPercent, title) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("li", {
      className: css.percent,
      children: "".concat(endPercent - 0, "%")
    }, "".concat(title, "-percent-0")), /*#__PURE__*/_jsx("li", {
      className: css.percent,
      children: "".concat(endPercent - 1, "%")
    }, "".concat(title, "-percent-1")), /*#__PURE__*/_jsx("li", {
      className: css.percent,
      children: "".concat(endPercent - 2, "%")
    }, "".concat(title, "-percent-2")), /*#__PURE__*/_jsx("li", {
      className: css.percent,
      children: "".concat(endPercent - 3, "%")
    }, "".concat(title, "-percent-3"))]
  });
};

var Blend = function Blend(_ref) {
  var description = _ref.description,
      features = _ref.features,
      percent = _ref.percent,
      showPercent = _ref.showPercent,
      title = _ref.title;
  return /*#__PURE__*/_jsxs("li", {
    className: css.blend,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.percentsContainer,
      children: /*#__PURE__*/_jsx("ul", {
        className: cc([css.percents, _defineProperty({}, css.showPercents, showPercent)]),
        children: getPercents(percent, title)
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: css.center,
      children: [/*#__PURE__*/_jsx("h3", {
        className: css.blendTitle,
        children: title
      }), /*#__PURE__*/_jsx("p", {
        className: css.description,
        children: description
      })]
    }), /*#__PURE__*/_jsx("ul", {
      className: css.features,
      children: features.map(function (feature) {
        return /*#__PURE__*/_jsx("li", {
          className: css.feature,
          children: feature
        }, feature);
      })
    })]
  });
};

Blend.propTypes = {
  description: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  percent: PropTypes.number.isRequired,
  showPercent: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired
};

var Blends = /*#__PURE__*/function (_PureComponent) {
  _inherits(Blends, _PureComponent);

  var _super = _createSuper(Blends);

  function Blends(props) {
    var _this;

    _classCallCheck(this, Blends);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "buildThreshold", function (steps) {
      return Array(steps + 1).fill(0).map(function (_, index) {
        return Math.round(index / steps * 100) / 100 || 0;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onIntersect", function (entries) {
      var _this$state = _this.state,
          showPercent = _this$state.showPercent,
          startThreshold = _this$state.startThreshold,
          currentTranslateY = _this$state.translateY;
      entries.forEach(function (entry) {
        var boundingClientRect = entry.boundingClientRect,
            intersectionRatio = entry.intersectionRatio,
            isIntersecting = entry.isIntersecting;
        var currentY = boundingClientRect.y;
        var inBounds = isIntersecting && intersectionRatio >= startThreshold;

        if (inBounds && !showPercent) {
          _this.setState({
            showPercent: true
          });
        }

        var scrollingDown = currentY < _this.previousY;
        var translateY = scrollingDown ? currentTranslateY + INCREMENT_AMOUNT : currentTranslateY - INCREMENT_AMOUNT;

        if (translateY < MAX_TRANSLATE) {
          _this.setState({
            translateY: translateY
          });
        }

        _this.previousY = currentY;
      });
    });

    _this.root = /*#__PURE__*/React.createRef();
    _this.state = {
      showPercent: false,
      startThreshold: 0.8,
      translateY: 0
    };
    return _this;
  }

  _createClass(Blends, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var rootHeight = this.root.current.offsetHeight;
      var roundedThreshold = Math.round(windowHeight() / rootHeight * 100) / 100;
      var startThreshold = Math.min(roundedThreshold, 0.5);
      this.setState({
        startThreshold: startThreshold
      });
      var threshold = this.buildThreshold(THRESHOLD_STEPS);
      this.observer = new IntersectionObserver(this.onIntersect, {
        threshold: threshold
      });
      this.observer.observe(this.root.current);
      this.previousY = 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          blends = _this$props.blends,
          cornerImage = _this$props.cornerImage,
          title = _this$props.title;
      var _this$state2 = this.state,
          showPercent = _this$state2.showPercent,
          translateY = _this$state2.translateY;
      return /*#__PURE__*/_jsxs("section", {
        className: css.root,
        ref: this.root,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.cornerImageWrap,
          style: {
            transform: "translate3d(0, ".concat(translateY, "px, 0)")
          },
          children: /*#__PURE__*/_jsx(LazyImg, {
            alt: "Fabric Example",
            className: css.cornerImage,
            src: cornerImage
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: css.overLayer,
          children: [/*#__PURE__*/_jsx("h2", {
            className: css.title,
            children: title
          }), /*#__PURE__*/_jsx("ul", {
            className: css.blends,
            children: blends.map(function (blend, blendIndex) {
              return /*#__PURE__*/_jsx(Blend, _objectSpread(_objectSpread({}, blend), {}, {
                showPercent: showPercent,
                isSecond: blendIndex > 0
              }), blend.title);
            })
          })]
        })]
      });
    }
  }]);

  return Blends;
}(PureComponent);

Blends.propTypes = {
  blends: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, Blend.propTypes))).isRequired,
  cornerImage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
export default Blends;